import React from "react";
import RepoItem from "./RepoItem";
import { Box, Typography } from "@material-ui/core";
const Repos = (props) => {
  return (
    <Box>
      <Typography variant="h4" align="center">
        Repositories
      </Typography>
      {props.repos.map((repo) => (
        <RepoItem repo={repo} key={repo.id}></RepoItem>
      ))}
    </Box>
  );
};

export default Repos;
